import React, { useEffect } from "react";
import styles from "./Transition.module.css";
import { useNavigate } from "react-router-dom";
import { generateMentorRecommendations } from "../../stores/recommendations/mentorRecommendationsSlice";
import { useAppDispatch } from "../../app/store";
import useTenant from "../../tenancy/useTenantPath";

export const NAME_URL_PARAM = "name";
export const SESSION_ID_URL_PARAM = "sessionId";
export const TIMESTAMP_START_URL_PARAM = "timestampStart";

const Transition = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const tenant = useTenant();

  useEffect(() => {
    let cancelled = false;

    const urlParams = new URLSearchParams(window.location.search);
    const userId = urlParams.get(NAME_URL_PARAM);
    const sessionId = urlParams.get(SESSION_ID_URL_PARAM);
    const timestampStart = urlParams.get(TIMESTAMP_START_URL_PARAM);

    if (!userId || !sessionId || !timestampStart) {
      console.info("Missing URL parameters");
      navigate(tenant.basePath + "/recommenderpage");
      return;
    }

    const generateAndNavigateRecommendations = async () => {
      try {
        const recommendations = await dispatch(
          generateMentorRecommendations({
            userId,
            sessionId,
            timestampStart,
          }),
        ).unwrap();

        if (cancelled) return;

        const firstRecommendation = recommendations.recommendedPages[0];

        const targetPage = firstRecommendation
          ? `/recommenderpage${firstRecommendation.pageRoute}`
          : "/recommenderpage";

        navigate(tenant.basePath + targetPage);
      } catch (error) {
        console.error("Failed to generate recommendations:", error);

        if (cancelled) return;
        else navigate(tenant.basePath + "/recommenderpage");
      }
    };

    void generateAndNavigateRecommendations();

    return () => {
      cancelled = true;
    };
  }, [dispatch, navigate, tenant.basePath]);

  return (
    <div>
      <div className={styles.loadingScreen} data-cy="transition-loading-screen">
        <div className={styles.dots}>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
        </div>
        <p className={styles.loadingText}>
          Gathering recommendations
          <br /> for next steps in your career exploration
        </p>
      </div>
    </div>
  );
};

export default Transition;
